
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/app/main/app.config.ts"
import cfg1 from "/app/layers/tairo/app.config.ts"
import cfg2 from "/app/node_modules/@shuriken-ui/nuxt/app.config.ts"
import cfg3 from "/app/layers/tairo-layout-sidebar/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, cfg1, cfg2, cfg3, inlineConfig)
